const basePath = ''

const origin = 'https://online.xueersi.com'
const protocol = 'https:' // process.env.VUE_ENV === 'client' ? 'https:' : 'http:'

let baseURL = `${protocol}//mall.xueersi.com`
// let baseURL = `${protocol}//api.xueersi.com/mall`
export { origin, protocol, baseURL, basePath }

console.log(995, baseURL, process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/config.js